
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { cleanupClaimKeyFromUrl } from "@/futurelayer/connector/connector";

@Component({})
export default class TopNavNotificationBarSuccess extends Vue {
  @Prop({ type: Boolean, default: false }) loading!: boolean;

  dismiss() {
    cleanupClaimKeyFromUrl();
    this.$emit('dismiss');
  }
}
